export default {
  serverUrl: process.env.VUE_APP_BATTLETRIS_SERVER,
  wsUrl: process.env.VUE_APP_BATTLETRIS_WS,
};
